<template>
  <div class="login">
    <content-spinner
      :show="true"
      :fullscreen="true"
    />
    <!--    <div class="container">
      <div class="form-wrapper">
        <div class="row">
          <div class="col-md-12 col-right">
            <div class="login-right text-center">
              <h3 class="login-heading text-white">Login to your account</h3>
              <br>
              <b-button variant="light" size="lg" class="btn-action" @click="onLoginClick()">Login with SSO</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import auth from '../../../core/services/auth.service';
import ContentSpinner from '../../../core/components/ContentSpinner';

export default {
  name: 'Login',
  components: {ContentSpinner},
  methods: {
    async onLoginClick() {
      await auth.signIn();
    },
  },
  async mounted() {
    setTimeout(async () => {
      if (!localStorage.getItem('LOGIN')) {
        await auth.signIn();
      }
    }, 1000);
  },
};
</script>

<style scoped lang="scss">
  @import "../../../core/scss/variables";

  @-webkit-keyframes mover {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-20px);
    }
  }

  @keyframes mover {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-20px);
    }
  }

  .login {
    width: 680px;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }

  .form-wrapper {
    padding: 50px;
    border-radius: 10px;
    background: -webkit-linear-gradient(top, darken($primary, 5%), lighten($primary, 10%));
  }

  .btn-secondary {
    border-radius: 1.5rem;
  }

  .btn-action {
    border-radius: 1.5rem;
    min-width: 160px;
  }

  .col-right {
    display: flex;
    align-items: center;
  }

  .login-right {
    flex: 1;
    padding: 30px 50px;
    /*background: #f8f9fa;*/
    border-top-left-radius: 10% 50%;
    border-bottom-left-radius: 10% 50%;
    border-top-right-radius: 10% 50%;
    border-bottom-right-radius: 10% 50%;
  }

  .login-heading {
    text-align: center;
    /*color: #495057;*/
  }

</style>
